import { Select, Breadcrumb, Button, Divider, Flex, Form, Image, Input, InputNumber, 
    Modal, Pagination, Skeleton, Tooltip, Upload, Row, Col } from 'antd';
import { Typography, notification } from 'antd';
import { UploadOutlined, UpCircleOutlined, SyncOutlined, FolderAddOutlined, 
    DeleteOutlined, DragOutlined, PlusCircleOutlined, FolderOutlined } from '@ant-design/icons';
import { useState } from 'react';
import Search from 'antd/es/input/Search';
import { useEffect } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { HomeOutlined } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import Password from 'antd/es/input/Password';
import GroupService from '../../services/widgetData'
import WidgetService from '../../services/widget'
import {useParams} from 'react-router-dom';


const { Option } = Select;
const { Title } = Typography;

const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 14,
      },
    },
  };

const WidgetData = (props) => {
    const params = useParams();

    const [isEdit, setIsEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [dynamicFields, setDynamicFields] = useState([]);  // Массив для хранения динамических полей

    const [imageOpen, setImageOpen] = useState(false);
    const [inQuery, setInQuery] = useState(false);
    const [form] = Form.useForm();

    const handleAddField = () => {
        setDynamicFields([...dynamicFields, { id: new Date().getTime() }]);  // Добавляем новое поле
    };

    const changeIdImage = (idImage) => {
        console.log(idImage)
        form.setFieldValue("id_image", idImage)
        setImageOpen(false)
    }

    const onGenderChange = (value) => {
      switch (value) {
        case 'male':
          form.setFieldsValue({
            note: 'Hi, man!',
          });
          break;
        case 'female':
          form.setFieldsValue({
            note: 'Hi, lady!',
          });
          break;
        case 'other':
          form.setFieldsValue({
            note: 'Hi there!',
          });
          break;
        default:
      }
    };

    useEffect(() => {
        console.log(params)

        if (params.id) {
            setIsEdit(true)

            // TODO 
            GroupService.read({id: Number(params.id)})
            .then(response => {
                if (response.status === 200) {
                    form.setFieldsValue(response.data.fields_data);
                    setDynamicFields(response.data.fields || []); // Add fields from the response

                    const dynamicFieldsValues = response.data.fields.reduce((acc, field) => {
                        acc[`dynamic_field_${field}`] = response.data.fields_data[field] || '';
                        return acc;
                    }, {});

                    console.log(dynamicFieldsValues);

                    form.setFieldsValue(dynamicFieldsValues);

                    setIsLoading(false)
                } else {
                    setIsError(true)
                }
            })
            .catch(e => {
                setIsError(true)
            });
        } else {
            setIsEdit(true)

            // TODO 
            WidgetService.read({id: Number(params.id_widget)})
            .then(response => {
                if (response.status === 200) {
                    form.setFieldsValue(response.data.Row);
                    setDynamicFields(response.data.fields || []); // Add fields from the response

                    setIsLoading(false)
                } else {
                    setIsError(true)
                }
            })
            .catch(e => {
                setIsError(true)
            });
        }
    }, []);

    const onFinish = (values) => {
        let request = {};
    
        // Переносим статические поля
        for (const property in values) {
            if (property && !property.startsWith('dynamic_field_')) {
                request[property] = values[property];
            }
        }
    
        // Собираем динамические поля в объект
        const dynamicFieldsValues = dynamicFields.reduce((acc, field, index) => {
            const i = dynamicFields[index];
            const fieldName = `dynamic_field_${i}`;
            const value = values[fieldName];
    
            // Assuming that the field name is part of the dynamicFields array (like 'test1', 'test2')
            // We assume the dynamic fields are named as 'test1', 'test2', etc.
            const dynamicFieldKey = field; // 'test1', 'test2', etc.
            acc[dynamicFieldKey] = value;
    
            return acc;
        }, {});
    
        // Добавляем динамические поля в запрос
        request.fields = dynamicFieldsValues;
    
        // Include the id if we are editing an existing entry
        if (params.id_widget) {
            request.id_widget = Number(params.id_widget);
        }
    
        setInQuery(true);
    
        if (params.id) {
            request.id = Number(params.id);
            GroupService.update(request)
                .then(response => {
                    if (response.status === 200) {
                        notification.success({
                            message: 'success',
                            description: 'Страница успешно обновлена',
                        });
                    } else {
                        notification.error({
                            message: 'Ошибка на сервере',
                            description: response.error ?? 'Неизвестная ошибка',
                            duration: 10,
                        });
                    }
                })
                .catch(e => {
                    notification.error({
                        message: 'Ошибка запроса',
                        duration: 10,
                        description: e.message,
                    });
                })
                .finally(() => {
                    setInQuery(false);
                });
        } else {
            GroupService.create(request)
                .then(response => {
                    if (response.status === 200) {
                        notification.success({
                            message: 'success',
                            description: 'Страница успешно добавлена',
                        });
                    } else {
                        notification.error({
                            message: 'Ошибка на сервере',
                            description: response.error ?? 'Неизвестная ошибка',
                            duration: 10,
                        });
                    }
                })
                .catch(e => {
                    notification.error({
                        message: 'Ошибка запроса',
                        duration: 10,
                        description: e.message,
                    });
                })
                .finally(() => {
                    setInQuery(false);
                });
        }
    };
     

    if (isLoading) {
        return (
            <>
                <div style={{paddingTop: '20px'}}>
                <Breadcrumb
                    separator=""
                    items={[
                        {
                            href: '/',
                            title: <HomeOutlined />,
                        },
                        {
                            type: 'separator',
                        },                    
                        {
                            href: '/widgets',
                            title: 'Виджеты',
                        },
                        {
                            type: 'separator',
                        },
                        {
                            href: `/widget/${params.id_widget}/widgetsdata`,
                            title: 'Данные',
                        }
                    ]}
                />
                </div>
                <Skeleton active />
            </>
        )
    }

    return (
    <>
            <div style={{paddingTop: '20px'}}>
                <Breadcrumb
                    separator=""
                    items={[
                        {
                            href: '/',
                            title: <HomeOutlined />,
                        },
                        {
                            type: 'separator',
                        },                    
                        {
                            href: '/widgets',
                            title: 'Виджеты',
                        },
                        {
                            type: 'separator',
                        },
                        {
                            href: `/widget/${params.id_widget}/widgetsdata`,
                            title: 'Данные',
                        }
                    ]}
                />
                </div>

                <Divider />

    <Form
        {...formItemLayout}
        form={form}
        onFinish={onFinish}
        style={{
            maxWidth: 1200,
        }}
    >

        {/* Dynamically render input fields based on the 'fields' array */}
        {dynamicFields.map((field, index) => (
            <Form.Item
                key={field} // Ensure field names are unique
                label={field}
                name={`dynamic_field_${field}`}
                rules={[
                    {
                        required: true,
                        message: `Поле ${field} не может быть пустым`,
                    },
                ]}
            >
                <Input maxLength={100} />
            </Form.Item>
        ))}  

        <Divider />

        <Form.Item>
            <Button 
                type="primary" htmlType="submit"
                loading={inQuery}
            >
            Сохранить
            </Button>
        </Form.Item>
    </Form>
    </>
    )
};

export default WidgetData;